import * as React from "react";
import { SVGProps } from "react";
const SvgLogout = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M18 4c1.654 0 3 1.346 3 3v4a1 1 0 0 1-2 0V7a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-4a1 1 0 0 1 2 0v4c0 1.654-1.346 3-3 3H8c-1.654 0-3-1.346-3-3V7c0-1.654 1.346-3 3-3h10Zm5.216 7.379a1 1 0 0 1 1.405-.163c1.923 1.523 3.298 2.903 4.203 4.218.234.34.234.792 0 1.133-.905 1.315-2.28 2.695-4.203 4.218a1 1 0 1 1-1.242-1.57 26.044 26.044 0 0 0 2.217-1.95l.261-.265H16a1 1 0 0 1-.117-1.994L16 15h9.857a25.23 25.23 0 0 0-2.478-2.215 1 1 0 0 1-.163-1.406Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgLogout;
